import React from "react";
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../hooks/useAuth';
import "./style.css";


export const TopMenuBar = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return (
        <div className="header-desktop">
            <div className="banner">
                <header className="header">
                    <img className="element-logo" src={require('../../assets/14bis-logo-horizontal.png')} />
                    <div className="tool-buttons">
                        <IconButton href="/" aria-label="home" className="button" size="small">
                            <HomeIcon className="button" />
                        </IconButton>
                        <IconButton onClick={() => navigate('/historyPage')} aria-label="profile" className="button" size="small">
                            <PersonIcon className="button" />
                        </IconButton>
                        <IconButton onClick={() => { logout(); navigate('/login'); }} aria-label="user" className="button" size="small">
                            <LogoutIcon className="button" />
                        </IconButton>
                    </div>
                </header>
            </div>
        </div>
    );
}
export default TopMenuBar;
